// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"79eafcd7","207":"ddc0a7bb","487":"99e469f3","678":"b5177dab","787":"b15f88dd","833":"4968b1c1"}[chunkId] + ".chunk.js";
};